import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuth();

  if (!user || (user.role !== 'super_admin' && user.role !== 'admin')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
